import {useTranslation} from "react-i18next";

interface TestimonialCardProps {
    item: TestimonialItem;
    index: number;
}

interface TestimonialItem {
    id: number;
    name: string;
    server: string;
    image: string | null;
}

export default function TestimonialCard({item, index}: TestimonialCardProps) {
    const { t } = useTranslation();
    return (
        <article
            className="testimonial-card"
            style={{animationDelay: `${index * 0.08}s`}}
        >
            <div className="testimonial-gradient-top"/>
            <div className="testimonial-glow"/>

            <div className="testimonial-content">
                <div>
                    <div className="testimonial-author">
                        <div className="author-avatar">
                            {item.image ? (
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="avatar-image"
                                    draggable={false}
                                />
                            ) : (
                                <div className="avatar-initials">
                                    {item.server.charAt(0).toUpperCase()}
                                </div>
                            )}
                        </div>

                        <div className="author-info">
                            <div className="author-name">
                                {item.name}
                            </div>
                            <div className="author-server">
                                {item.server}
                            </div>
                        </div>
                    </div>

                    <p className="testimonial-quote">
                        <span className="quote-text">{t(`home.testimonials.messages.${item.id}`)}</span>
                    </p>
                </div>

                <div className="testimonial-divider"/>

                <div className="testimonial-footer">
                    <div className="metric-bar"/>
                </div>
            </div>
        </article>
    );
}